import { showLoadingIndicator, hideLoadingIndicator } from './actions/creators';

export const callWithLoadingIndicator = (key, longRunningCall) => (dispatch) => {
  dispatch(showLoadingIndicator(key));
  return longRunningCall().finally(() => dispatch(hideLoadingIndicator(key)));
};